module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"room":"Room type","unit":"Unit","checkIn":"Check In","checkOut":"Check Out","guests":"Number of Guests","nights":"Nights","date":"Date","referer":"Referer"},"sl":{"room":"Tip sobe","unit":"Enota","checkIn":"Prihod","checkOut":"Odhod","guests":"Število gostov","nights":"Nočitve","date":"Datum","referer":"Kanal"}}')
  delete Component.options._Ctor
}
